<template>
<v-layout row wrap>
  <v-flex md12>
    <!-- <span @click="checkAllWaiting()">Select All</span> -->
    <v-list>
      <draggable v-model="Waiting_list_pd" :options="{disable:false,draggable:'.item',group:'lists'}" class="minhgt" @end="updateAppointmentPosition" id="waiting" :move="onMove">
        <div v-for="Waiting_list in Waiting_list_pd" class="item">
          <Patient
          :id="Waiting_list.id"
          :name="Waiting_list.name"
          :image="Waiting_list.image_new"
          :gender="Waiting_list.gender"
          :age="Waiting_list.age"
          :place="Waiting_list.place"
          :lastVisit="Waiting_list.previous_appointment"
          :order="Waiting_list.order"
          :vitals="Waiting_list.vitals"
          :print="Waiting_list.print"
          :person_id="Waiting_list.person_id"
          :billing="Waiting_list.billing"
          :critical="Waiting_list.is_critical"
          :criticalOn="Waiting_list.critical_on"
          :selectPatient="QueuePatientProfile"
           />
        </div>
      </draggable>
    </v-list>
  </v-flex>
  <v-dialog max-width="800px" v-model="dialogProfileVisible" :lock-scroll="true" :scrollable="true" >
  <v-flex xs12>
    <v-card class="the--card">
      <v-layout row wrap>
        <v-flex xs12>
          <v-btn icon @click.native="dialogProfileVisible = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <ViewProfile :manageProfile="!dialogProfileVisible" :selectedPatients="selectedPatient"></ViewProfile>
    </v-card>
  </v-flex xs12>
</v-dialog>
</v-layout>

</template>
<script>
import $ from 'jquery';
import Patient from './Patient';
import draggable from 'vuedraggable';
import { mapState, mapActions, mapMutations } from 'vuex';
import ViewProfile from './ViewProfile';
export default {
  name: 'PatientList',
  components: {
    Patient,
    draggable,
    ViewProfile
  },
  props: ['selectPatient'],
  data() {
    return {
      dialogProfileVisible: false
    };
  },

  computed: {
    Waiting_list_pd: {
      get() {
        return this.$store.state.Waiting_list_pd;
      },
      set(value) {
        this.$store.commit('update_Waiting_list', value);
      }
    }
  },

  methods: {
    ...mapActions(['getdata', 'changeAppointmentPosition', 'updateQueues']),
    ...mapMutations(['onEnd']),
    onMove(evt) {
      if (evt.to.id == 'completed') {
        return true;
      } else {
        return false;
      }
    },
    QueuePatientProfile(id) {
      const Patients = this.Waiting_list_pd.filter(
        data => data.person_id === id
      );
      this.selectedPatient = Patients[0];
      this.dialogProfileVisible = true;
    },
    updateAppointmentPosition(ev, i) {
      const eventIdArray = ev.to.id.split('-');
      const eventToId = eventIdArray[eventIdArray.length - 1];
      console.log(eventToId);
      // if (eventToId === "completed") {
      //   return true;
      // }
      // else{
      //   return false;
      // }

      let payload = {};
      if (ev.from.id == eventToId) {
        if (ev.oldIndex == ev.newIndex) {
          return;
        }

        // If you drag and drop a element at the end of list then you have to send the previous element's order
        if (this.Waiting_list_pd.length == ev.newIndex + 1) {
          console.log(ev.newIndex);
          payload.order = this.Waiting_list_pd[ev.newIndex - 1].order;
        } else if (ev.oldIndex == 0 && ev.newIndex == 1) {
          // If you drag and drop the first element to second element then you have send 0th element's order
          console.log(ev.newIndex);
          payload.order = this.Waiting_list_pd[0].order;
        } else {
          //  Otherwise you have to send the next element's order
          console.log('ds');
          let o = ev.newIndex > ev.oldIndex ? ev.newIndex - 1 : ev.newIndex + 1;
          console.log(o);
          payload.order = this.Waiting_list_pd[o].order;
        }

        payload.qid = this.Waiting_list_pd[ev.newIndex].id;
        payload.state = null;
        this.$store.dispatch('updateQue', payload);
      } else {
        payload.state = eventToId == 'completed' ? 2 : 1;
        switch (payload.state) {
          case 1:
            console.log(
              this.$store.state.queue_patient_details[eventToId].info.length
            );
            if (
              this.$store.state.queue_patient_details[eventToId].info.length ==
              1
            ) {
              payload.order = 0;
            } else {
              payload.order =
                this.$store.state.queue_patient_details[eventToId].info[
                  ev.newIndex - 1
                ].order || 0;
            }
            payload.qid = this.$store.state.queue_patient_details[
              eventToId
            ].info[ev.newIndex].id;
            break;
          case 2: {
            payload.order = 0;
            const hasOrder =
              this.$store.state.queue_completed_pd[ev.newIndex + 1] &&
              'order' in this.$store.state.queue_completed_pd[ev.newIndex + 1];
            if (hasOrder) {
              payload.order = this.$store.state.queue_completed_pd[
                ev.newIndex + 1
              ].order;
            }

            payload.qid = this.$store.state.queue_completed_pd[ev.newIndex].id;
          }
        }
        this.$store.dispatch('updateQue', payload);
      }
    }
  }
};
</script>
<style scoped>
.item {
  border-bottom: 0.5px solid #e0e0e0;
  /* padding: 0.5rem 0rem; */
  /* height: 60px; */
}

/* .item .list__tile {
  height: 65px;
} */

.patient_details {
  display: flex;
  justify-content: space-around;
}

.minhgt {
  min-height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/WaitingList.vue